require('../vendor/turnjs4/lib/turn.min');
require('../vendor/turnjs4/lib/zoom.min');



$(window).ready(function() {

  var viewportHeight = Math.max(document.documentElement.clientHeight, window.outerHeight || 0)

  if(screen.width < 600) {
    var mobile = true;
    var display = 'single';

    var when = {
      start: function (event, pageObject, corner) {
        if (corner != null) {
          $(this).turn('data').hover = true;
          return event.preventDefault();
        }
      },
      turning: function (event, page, newView) {
        if ($(this).turn('data').hover) {
          $(this).turn('data').hover = false;
          event.preventDefault();
        }
      }
    };

  }else {
    var mobile = false;
    var display = 'double';

    var when = {
      turned: function(e, page) {
        if(page == 1) {
          $('.c-booklet__magazine').turn('peel','tr');
        }

        if($('.c-booklet__magazine').turn('pages') == page) {
          $('.c-booklet__magazine').turn('peel','tl');
        }
      }
    };

  }

  $('.c-booklet__magazine').turn({
    display: display,
    acceleration: true,
    height: viewportHeight,
    autoCenter: true,
    when: when
  });

  if(!mobile) {
    $('.c-booklet__magazine').turn('peel','tr');
  }

  //Optional, calls the resize function when the window changes, useful when viewing on tablet or mobile phones
  $(window).resize(function() {
    resizeViewport();
  }).bind('orientationchange', function() {
    resizeViewport();
  });

  //Must be called initially to setup the size
  resizeViewport();

});

$(window).bind('keydown', function(e){
  if (e.keyCode==37)
    $('.c-booklet__magazine').turn('previous');
  else if (e.keyCode==39)
    $('.c-booklet__magazine').turn('next');
});

function resizeViewport() {
  var width = $(window).width(),
    height = $(window).height(),
    options = $('.c-booklet__magazine').turn('options');

  $('.c-booklet__magazine-viewport').css({
    width: width,
    height: height
  });
}
